<template>
  <div class="blackScroll">
    <EmoticonSelector :user="user" ref="EmoticonSelector"></EmoticonSelector>
    <GifSelector :user="user" ref="GifSelector"></GifSelector>
    <RoomChange ref="RoomChange"></RoomChange>

    <tap-target
      :show="showTutorial"
      :target="tapTargetFocus"
      size="60vh"
      backgroundColor="rgba(40,40,40,1)"
      color="#ffffff"
      contentLocation="sw"
      :title="targetTitle"
      :content="targetContent"
      @close="showTutorial = false"
    />

    <!-- <v-slide-x-transition>
        <div
          style="position:absolute; left:12px; top:12px; z-index:10000"
        >
          <v-btn fab small class="pl-0" color="rgb(20,20,20)">
            <img
          to="/"
          width="42px"
          height="42px"
          class="mt-3"
          :src="require('@/assets/logo.png')"
      />
          </v-btn>
        </div>
      </v-slide-x-transition> -->

    <v-btn
      icon
      color="white"
      v-if="$vuetify.breakpoint.smAndDown"
      @click.stop="$root.setSidebar(true)"
      style="z-index: 1; position: absolute; top: 16px; left: 16px"
      ><v-icon>mdi-menu</v-icon></v-btn
    >
    <div
      id="videoPlayer"
      :class="{ streaming: streaming }"
      :style="{
        height: 'calc(100% - ' + (theatreMode ? 90 : 110) + 'px)',
        width:
          'calc(100% - ' +
          (theatreMode == 2 || $vuetify.breakpoint.smAndDown ? 0 : 350) +
          'px)'
      }"
      style="overflow-y: hidden !important"
    >
      <video
        ref="player"
        v-show="streaming && !joining"
        width="100%"
        height="100%"
        :muted="muted"
        autoplay
      ></video>
      <Reactions
        ref="reactionRenderer"
        :render="user.displayReactions"
        style="position: absolute; bottom: 0 !important; right: 0"
      ></Reactions>
      <v-slide-y-transition>
        <v-container v-if="joining && !streaming" fill-height text-center style>
          <v-layout row align-center>
            <v-row justify="center">
              <v-col v-if="!streaming" cols="12">
                <v-progress-circular
                  indeterminate
                  color="white"
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-layout>
        </v-container>
        <v-container
          v-if="joining && streaming"
          class="clickable"
          @click="
            joining = false;
            muted = false;
            $refs.player.play();
          "
          fill-height
          text-center
          style
        >
          <v-layout row align-center>
            <v-row justify="center">
              <v-col cols="12">
                <h1 class="white--text display-2 clickable">Click to play!</h1>
              </v-col>
            </v-row>
          </v-layout>
        </v-container>
        <v-container
          v-if="!privateRoom && !publicRoom && !streaming && !joining"
          fill-height
          text-center
          style
        >
          <v-layout row align-center>
            <v-row justify="center">
              <v-col cols="11">
                <h1 class="white--text">What do you want to do?</h1>
              </v-col>
              <v-col cols="10" sm="10" md="4" lg="3" xl="2">
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    @click="privateRoom = true"
                    :elevation="hover ? 24 : 2"
                    class="text-center clickable"
                  >
                    <v-card-title
                      class="justify-center pb-2"
                      style="word-break: break-word"
                      >Open Private Room</v-card-title
                    >
                    <v-card-text class="black--text"
                      >Open a private, unlisted room for your
                      friends!</v-card-text
                    >
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="10" sm="10" md="4" lg="3" xl="2">
                <v-hover v-slot:default="{ hover }">
                  <v-tooltip bottom :disabled="user.tier !== false && user.tier !== 'Friend'">
                    <template v-slot:activator="{ on }">
                      <v-card
                        @click="user.tier !== false && user.tier !== 'Friend' ? (publicRoom = true) : null"
                        :elevation="hover ? 24 : 2"
                        :disabled="user.tier == false || user.tier == 'Friend'"
                        class="text-center"
                        :class="{ clickable: user.tier !== false && user.tier !== 'Friend' }"
                        style="pointer-events: all"
                        v-on="on"
                      >
                        <v-card-title
                          class="justify-center pb-2"
                          style="word-break: break-word"
                          >Host Public Room</v-card-title
                        >
                        <v-card-text class="black--text"
                          >Host a publicly listed room for
                          everyone!</v-card-text
                        >
                      </v-card>
                    </template>
                    <span>Subscribe to use this feature!</span>
                  </v-tooltip>
                </v-hover>
              </v-col>
              <!-- <v-col cols="12" sm="10" md="4" lg="3" xl="2" v-if="user.tier">
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    @click="publicRoom = true"
                    :elevation="hover ? 24 : 2"
                    :disabled="!user.tier"
                    class="text-center"
                    :class="{ clickable: user.tier }"
                    style="pointer-events:all"
                    v-on="on"
                  >
                    <v-card-title class="justify-center pb-2">Host a Public Room</v-card-title>
                    <v-card-text class="black--text">
                      Host a publicly listed room and meet new
                      people!
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>-->
            </v-row>
          </v-layout>
        </v-container>
      </v-slide-y-transition>
      <v-slide-y-reverse-transition>
        <v-container v-if="privateRoom" fill-height text-center style>
          <v-layout row align-center>
            <v-row justify="center">
              <v-col cols="11" sm="10" md="6" lg="4" xl="3">
                <v-card class="text-center">
                  <v-btn text @click="privateRoom = false">Back</v-btn>
                  <v-card-text class="black--text text-center pt-1 pb-2">
                    <v-form ref="privateForm" @submit.prevent>
                      <v-input style="margin-bottom: -24px">
                        <v-row no-gutters class="mb-0 pb-0">
                          <v-col cols="11" class="ma-0 pa-0 mx-auto">
                            <v-text-field
                              aria-autocomplete="false"
                              v-model="privateRoomName"
                              background-color="grey lighten-3"
                              color="white"
                              class=""
                              label="Room name"
                              solo
                              counter
                              maxlength="24"
                              validate-on-blur
                              :rules="roomNameRules"
                            ></v-text-field>
                            <v-textarea
                              aria-autocomplete="false"
                              color="black"
                              v-model="privateRoomDescription"
                              background-color="grey lighten-3"
                              class="roomDescriptionInput whiteScroll"
                              counter
                              solo
                              no-resize
                              maxlength="128"
                              :rules="roomDescriptionRules"
                              validate-on-blur
                            >
                              <template v-slot:label>
                                <div>Description <small>(optional)</small></div>
                              </template></v-textarea
                            >
                          </v-col>
                        </v-row>
                      </v-input>
                      <v-layout column align-center>
                        <v-switch
                          v-if="user.tier == false || user.tier == 'Friend'"
                          :disabled="user.tier == false || user.tier == 'Friend'"
                          :input-value="false"
                          color="black"
                          class="mt-0 pt-0 text-center"
                          style="height: 36px"
                          label="Use Relay"
                        >
                          <v-tooltip slot="append" right v-if="!user.tier || user.tier == 'Friend'">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" style="pointer-events: all"
                                >mdi-information</v-icon
                              >
                            </template>
                            <span>Subscribe to use this feature!</span>
                          </v-tooltip>
                        </v-switch>
                      </v-layout>
                      <v-btn
                        class="mt-1 pt-0"
                        block
                        dark
                        :loading="privateButtonLoading"
                        @click="hostPrivate()"
                      >
                        <v-tooltip bottom v-if="user.tier && user.tier !== 'Friend'">
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              color="grey"
                              style="
                                pointer-events: all;
                                position: absolute;
                                left: 0;
                              "
                              >mdi-patreon</v-icon
                            >
                          </template>
                          <span>Routing through the relay server!</span>
                        </v-tooltip>
                        Select screen
                      </v-btn>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-layout>
        </v-container>
      </v-slide-y-reverse-transition>
      <v-slide-y-reverse-transition>
        <v-container v-if="publicRoom" fill-height text-center style>
          <v-layout row align-center>
            <v-row justify="center">
              <v-col cols="11" sm="10" md="6" lg="5" xl="3">
                <v-card class="text-center whiteScroll">
                  <v-btn text @click="publicRoom = false">Back</v-btn>
                  <v-card-text class="text-center pt-1 pb-2 whiteScroll">
                    <v-form ref="publicForm" @submit.prevent>
                      <v-input style="height: 312px !important;" class="whiteScroll">
                        <v-spacer></v-spacer>
                        <v-col cols="11" class="ma-0 pa-0 whiteScroll">
                          <v-text-field
                            v-model="publicRoomName"
                            background-color="grey lighten-3"
                            solo
                            validate-on-blur
                            class="mt-0 pt-0"
                            label="Room name"
                            counter
                            maxlength="24"
                            aria-autocomplete="false"
                            :rules="roomNameRules"
                          ></v-text-field>
                          <v-textarea
                            aria-autocomplete="false"
                            color="black"
                            v-model="publicRoomDescription"
                            background-color="grey lighten-3"
                            class="roomDescriptionInput whiteScroll"
                            counter
                            solo
                            no-resize
                            maxlength="128"
                            :rules="publicRoomDescriptionRules"
                            validate-on-blur
                          >
                            <template v-slot:label>
                              <div>Description</div>
                            </template></v-textarea
                          >
                          <v-text-field
                            v-model="coverURL"
                            background-color="grey lighten-3"
                            solo
                            validate-on-blur
                            class="pt-0"
                            label="Cover image URL"
                            counter
                            maxlength="2000"
                            aria-autocomplete="false"
                            :rules="coverURLRules"
                            :error-messages="coverURLErrors"
                          ></v-text-field>
                          <v-select
                            v-model="categorySelector"
                            background-color="grey lighten-3"
                            style="width:50% !important"
                            class="pr-3 whiteScroll CategorySelector"
                            solo
                            validate-on-blur
                            label="Category"
                            attach
                            chips
                            :rules="categoryRules"
                            :items="
                              categories.map(obj => {
                                return obj.name;
                              })
                            "
                          >
                            <template v-slot:selection="{ item, index }">
                              <v-chip
                                v-if="index < 2"
                                :class="findColour(item, categories)"
                                class="white--text"
                              >
                                <span>{{ item }}</span>
                              </v-chip>
                              <span
                                v-if="index == 2"
                                class="grey--text caption"
                              >
                                (+{{ categorySelector.length - 2 }} other{{
                                  categorySelector.length - 2 > 1 ? "s" : ""
                                }})
                              </span>
                            </template>
                          </v-select>
                          <v-switch
                            v-model="unlistRoom"
                            color="black"
                            class="ma-0 pa-0 mb-5 mx-auto pr-2"
                            style="position:absolute; bottom:45px; right:0; height: 1px; margin-top: -8px !important; width:50%"
                            label="Unlist Room"
                          >
                            <v-tooltip slot="append" right>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" style="pointer-events: all"
                                  >mdi-information</v-icon
                                >
                              </template>
                              <span v-if="!unlistRoom">
                                Removes your room from the public listings
                              </span>
                              <span v-else>
                                Adds your room to the public listings
                              </span>
                            </v-tooltip>
                          </v-switch>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-input>
                    </v-form>
                    <!-- <div v-if="user.tier == 'Supporter'" class="black--text mt-1 mb-2">
                      You can stream to 15 viewers!
                    </div>
                    <div v-if="user.tier == 'Advocate'" class="black--text mt-1 mb-2">
                      You can stream to 30 viewers!
                    </div> -->
                    <v-btn
                      class="pt-0 mt-2"
                      block
                      dark
                      @click="hostPublic()"
                      :loading="publicButtonLoading"
                    >
                      <v-tooltip bottom v-if="user.tier && user.tier !== 'Friend'">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            color="grey"
                            style="
                              pointer-events: all;
                              position: absolute;
                              left: 0;
                            "
                            >mdi-patreon</v-icon
                          >
                        </template>
                        <span>Routing through the relay server!</span>
                      </v-tooltip>
                      Select screen
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-layout>
        </v-container>
      </v-slide-y-reverse-transition>
    </div>
    <div
      id="underVideo"
      class="text-center"
      :style="{
        height: (theatreMode ? 90 : 110) + 'px',
        width:
          'calc(100% - ' +
          (theatreMode == 2 || $vuetify.breakpoint.smAndDown ? 0 : 350) +
          'px)'
      }"
      style="overflow: visible"
    >
      <div id="controls">
        <v-row no-gutters class="mt-1">
          <v-col cols="1" v-if="!isMobile()">
            <v-btn
              text
              icon
              color="white"
              class="mr-1"
              :disabled="!streaming || viewer !== null"
              :class="{ disabled: !streaming || viewer !== null }"
              @click.native.stop.prevent="videoQualityToggle()"
            >
              <v-icon>
                {{ qualitySetting ? "mdi-quality-high" : "mdi-quality-low" }}
              </v-icon>
            </v-btn>
          </v-col>

          <v-col
            :cols="isMobile() ? 4 : 3"
            style="padding-top: 2px"
            class="black--text"
          >
            <v-slider
              :prepend-icon="volumeIcon"
              v-model="volumeSlider"
              color="white"
              track-color="black"
              thumb-color="white"
              :dense="true"
              dark
              :disabled="!streaming"
              :class="isMobile() ? 'pl-2' : ''"
              @click:prepend="volumeToggle"
            >
              <template v-slot:thumb-label>
                <span class="black--text font-weight-bold">{{
                  volumeSlider
                }}</span>
              </template>
            </v-slider>
          </v-col>
          <v-col cols="1" md="2" lg="2" xl="2">
            <v-btn
              icon
              color="white"
              class="mr-1"
              :disabled="!streaming"
              :class="{ disabled: !streaming }"
              @click.native.stop.prevent="videoFullscreen()"
            >
              <v-icon>mdi-fullscreen</v-icon>
            </v-btn>
            <v-btn
              v-if="!$vuetify.breakpoint.smAndDown"
              icon
              color="white"
              class="mr-1"
              :disabled="!streaming"
              :class="{ disabled: !streaming }"
              @click.native.stop.prevent="changeTheatreMode()"
            >
              <v-icon size="22">mdi-monitor</v-icon>
            </v-btn>
          </v-col>
          <!-- <v-icon
              class="mb-4 mr-3"
              :disabled="!streaming"
              @click="theatreMode = !theatreMode"
            >
              {{ theatreMode ? "mdi-rectangle-outline" : "mdi-aspect-ratio" }}
            </v-icon> -->
          <v-col
            :class="{ disabled: !streaming || !user.displayReactions }"
            class="text-right mr-1"
          >
            <ul
              id="emoticons"
              style="padding-left: 0"
              :class="{ disabled: !streaming || !user.displayReactions }"
            >
              <v-icon
                big
                class="mb-3 mr-3"
                :class="{ notClickable: !streaming }"
                @click="streaming ? toggleDisplayReactions() : null"
                >{{ user.displayReactions ? "mdi-eye" : "mdi-eye-off" }}</v-icon
              >
              <li
                v-for="(emoticon, index) in emoticons"
                :key="'emoticon' + index"
              >
                <v-tooltip bottom :disabled="!host || !user.displayReactions">
                  <template v-slot:activator="{ on }">
                    <img
                      v-on="on"
                      :class="{ clickable: streaming && user.displayReactions }"
                      @click="
                        streaming && user.displayReactions
                          ? sendReaction(emoticon)
                          : null
                      "
                      @contextmenu="
                        host && user.displayReactions
                          ? ($event.preventDefault(), swapEmoticon(index))
                          : null
                      "
                      :src="
                        require('@/assets/emoticons/' +
                          twemoji.convert.toCodePoint(emoticon) +
                          '.png')
                      "
                      width="20px"
                      height="20px"
                    />
                  </template>
                  <span>Right click to change</span>
                </v-tooltip>
              </li>
              <v-menu
                offset-y
                open-on-hover
                nudge-left="220px"
                close-delay="200"
                nudge-top="232px"
                :close-on-click="false"
                :close-on-content-click="false"
                class="blackScroll"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    big
                    class="mb-3 mr-1 ml-0 pl-0"
                    :class="{ notClickable: !streaming }"
                    :disabled="streaming !== true || !user.displayReactions"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-chevron-up</v-icon
                  >
                </template>
                <v-card
                  height="200px"
                  width="253px"
                  color="rgba(20,20,20,0.5)"
                  class="blackScroll"
                  id="customScroll"
                  style="overflow-y: scroll"
                >
                  <v-card-text class="pr-0 pl-1 pt-2 pb-0 blackScroll">
                    <ul id="emoticonss" class="blackScroll">
                      <li
                        v-for="(emoticon, index) in allEmoticons"
                        :key="index"
                        class="blackScroll"
                      >
                        <img
                          class="clickable"
                          @click="
                            streaming && user.displayReactions
                              ? sendReaction(emoticon)
                              : null
                          "
                          :src="
                            require('@/assets/emoticons/' +
                              twemoji.convert.toCodePoint(emoticon) +
                              '.png')
                          "
                          width="20px"
                          height="20px"
                        />
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-menu>
            </ul>
          </v-col>
        </v-row>
      </div>
      <ul
        id="users"
        class="mt-12 pl-0"
        :style="{ height: theatreMode ? '45px' : '65px' }"
      >
        <li
          v-for="(avatarUser, index) in users"
          :key="'avatarUser' + index"
          class="ml-2 mb-2"
        >
          <v-menu
            :v-model="'menu' + index"
            class="userMenuHover"
            attach="#users"
            :close-on-content-click="true"
            open-on-hover
            top
            offset-y
            style="z-index: 10000 !important"
            :nudge-left="
              !hostInURL(avatarUser)
                ? avatarUser.username.length * 5.25 + 'px'
                : '80px'
            "
          >
            <template v-slot:activator="{ on }" class="userMenuHover">
              <v-avatar
                :size="theatreMode ? 40 : 60"
                v-on="on"
                :color="!avatarUser.avatar ? 'rgb(20,20,20)' : ''"
              >
                <v-img
                  v-if="avatarUser.avatar"
                  :src="avatarUser.avatar"
                ></v-img>
                <span v-else class="white--text text-h5 font-weight-light">{{
                  avatarUser.username.substring(0, 2)
                }}</span>
              </v-avatar>
            </template>
            <v-card dark style="z-index: 1000 !important" class="userMenuHover">
              <v-list>
                <v-list-item>
                  <v-avatar
                    :color="!avatarUser.avatar ? 'rgb(20,20,20)' : ''"
                    class="ml-0 pl-0 mr-2"
                  >
                    <v-img
                      v-if="avatarUser.avatar"
                      :src="avatarUser.avatar"
                    ></v-img>
                    <span
                      v-else
                      class="white--text text-h6 font-weight-light"
                      >{{ avatarUser.username.substring(0, 2) }}</span
                    >
                  </v-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ avatarUser.username }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider v-if="avatarUser.id !== user.id"></v-divider>
              <div class="text-center" v-if="hostInURL(avatarUser)">
                <v-btn class="ma-2" @click="kickViewer(avatarUser)">Kick</v-btn>
                <v-btn
                  color="white"
                  class="ma-2"
                  icon
                  @click="friendViewer(avatarUser)"
                >
                  <v-icon>mdi-account-plus</v-icon>
                </v-btn>
                <v-btn color="red" class="ma-2" @click="banViewer(avatarUser)"
                  >Ban</v-btn
                >
              </div>
              <div v-else-if="avatarUser.id !== user.id" class="text-center">
                <v-btn
                  color="white"
                  class="ma-2"
                  icon
                  @click="friendViewer(avatarUser)"
                >
                  <v-icon>mdi-account-plus</v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-menu>
        </li>
      </ul>
    </div>

    <v-navigation-drawer
      id="sidebar"
      v-show="theatreMode !== 2"
      absolute
      permanent
      stateless
      color="rgb(30,30,30)"
      floating
      right
      height="100%"
      :style="{
        position: $vuetify.breakpoint.smAndDown ? 'absolute' : '',
        top: $vuetify.breakpoint.smAndDown ? '100vh' : '',
        width: $vuetify.breakpoint.smAndDown ? '100%' : '350px'
      }"
    >
      <v-hover v-slot:default="{ hover }">
        <v-list-item two-line ref="topHeader" v-if="users.length">
          <v-avatar
            :color="!users[0].avatar ? 'rgb(20,20,20)' : ''"
            class="mr-3 pl-0 ml-0"
            size="40px"
          >
            <img v-if="users[0].avatar" :src="users[0].avatar" />
            <span v-else class="white--text text-h6 font-weight-light">{{
              users[0].username.substring(0, 2)
            }}</span>
          </v-avatar>

          <v-slide-x-reverse-transition>
            <v-btn
              color="rgb(20,20,20)"
              class="float-right"
              style="
                background-color: rgb(15, 15, 15);
                position: absolute;
                right: 12px;
              "
              fab
              small
              :disabled="!host"
              @click="
                $refs.RoomChange.open(
                  roomName,
                  roomDescription,
                  roomID,
                  isPublic,
                  roomCategory,
                  roomCoverURL,
                  roomIsListed
                )
              "
              v-show="hover && host"
            >
              <v-icon color="white">mdi-pencil</v-icon>
            </v-btn>
          </v-slide-x-reverse-transition>

          <v-list-item-content ref="roomInformation">
            <v-list-item-title
              style="text-transform: capitalize"
              class="white--text"
              :class="{ 'text-h6': roomName.length }"
              >{{
                !roomName.length
                  ? users.length
                    ? users[0].username
                    : ""
                  : roomName
              }}</v-list-item-title
            >
            <v-list-item-subtitle
              style="white-space: pre-line"
              class="grey--text text--lighten-1"
              v-text="
                roomDescription.length
                  ? roomDescription
                  : users.length
                  ? 'Hosting room'
                  : ''
              "
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-hover>
      <v-divider></v-divider>
      <div
        id="chat"
        ref="chat"
        style="z-index: 2 !important; overflow-x: hidden"
        :style="{ height: `calc(100% - ${String(72 + topHeaderOffset)}px)` }"
      >
        <v-row style="max-width: 101% !important; z-index: 500 !important">
          <v-col cols="12" class="pt-0 pb-0">
            <v-list class="pt-0 pb-0 hidden-h-scroll">
              <v-list-item
                class="messages pl-3"
                v-for="(message, index) in messages"
                :key="'message' + index"
                :three-line="false"
                style="align-items: start !important"
              >
                <v-hover v-slot:default="{ hover }">
                  <div
                    style="
                      width: 100%;
                      display: contents;
                      z-index: 505 !important;
                      padding-top: 12px;
                    "
                  >
                    <!-- <v-list-item-avatar size="32" class="pt-0">
                      <img :src="message.user.avatar" />
                    </v-list-item-avatar> -->

                    <v-avatar
                      size="32"
                      :color="!message.user.avatar ? 'rgb(20,20,20)' : ''"
                      class="mr-3"
                    >
                      <v-img
                        v-if="message.user.avatar"
                        :src="message.user.avatar"
                      ></v-img>
                      <span
                        v-else
                        class="white--text text-subtitle-1 font-weight-light"
                        >{{ message.user.username.substring(0, 2) }}</span
                      >
                    </v-avatar>

                    <v-slide-x-reverse-transition>
                      <v-btn
                        color="white"
                        class="float-right"
                        style="
                          background-color: rgb(15, 15, 15);
                          position: absolute;
                          top: 16px;
                          right: -17px;
                        "
                        small
                        icon
                        v-show="
                          hover &&
                            (hostInURL(message.user) ||
                              message.user.id == user.id)
                        "
                        :class="{ 'disabled-button': message.deleted }"
                        @click="deleteMessage(message)"
                      >
                        <v-icon
                          :color="message.deleted ? 'grey darken-2' : 'white'"
                          small
                          >{{
                            message.deleted ? "mdi-delete-off" : "mdi-delete"
                          }}</v-icon
                        >
                      </v-btn>
                    </v-slide-x-reverse-transition>

                    <v-list-item-content>
                      <v-list-item-title class="white--text">
                        {{ message.user.username }}
                        <span class="grey--text text--darken-1 caption">
                          {{ formatDate(message.timestamp) }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-subtitle
                        :class="
                          message.deleted
                            ? 'text--darken-1 font-italic'
                            : 'text--lighten-1'
                        "
                        class="grey--text"
                        v-html="message.presentable"
                        >{{ message.presentable }}</v-list-item-subtitle
                      >
                      <img
                        v-if="message.image"
                        :src="message.image"
                        :load="onMessageImageLoad()"
                        onload="this.style.display='initial'"
                        style="object-fit: contain; max-height: 150px"
                        onerror="this.style.display='none'"
                      />
                    </v-list-item-content>
                  </div>
                </v-hover>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </div>
      <v-divider
        style="background-color: rgb(20, 20, 20); height: 1px"
      ></v-divider>
      <div id="chatInput">
        <v-row>
          <v-form
            ref="messageForm"
            style="width: 100%"
            autocomplete="off"
            @submit.prevent="sendMessage()"
          >
            <v-input>
              <v-spacer></v-spacer>
              <v-tooltip
                nudge-right="39px"
                nudge-bottom="16px"
                top
                :disabled="user.email.verified"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-col cols="8" v-on="on" v-bind="attrs">
                    <v-text-field
                      v-model="messageInput"
                      :disabled="!streaming || !user.email.verified"
                      placeholder="Message"
                      maxlength="512"
                      single-line
                      :error-messages="messageErrors"
                      dark
                    ></v-text-field>
                  </v-col>
                </template>
                <span>You must verify your email in order to chat!</span>
              </v-tooltip>
              <v-tooltip top :disabled="user.tier !== false">
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="1"
                    class="pa-0 mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-btn
                      :disabled="!streaming || !user.tier"
                      icon
                      color="white"
                      @click="openGifs()"
                    >
                      <v-icon>mdi-gif</v-icon>
                    </v-btn>
                  </v-col>
                </template>
                <span>Subscribe to use this feature!</span>
              </v-tooltip>
              <v-col cols="1" class="pa-0 mr-2">
                <v-menu
                  open-on-hover
                  top
                  offset-y
                  nudge-top="10px"
                  :close-on-click="false"
                  :close-on-content-click="false"
                  close-delay="200"
                  @input="notificationSoundMenu()"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="white"
                      :disabled="!streaming"
                      v-bind="attrs"
                      v-on="on"
                      @click="chatNotifications()"
                    >
                      <v-icon>{{
                        user.chatNotifications ? "mdi-bell" : "mdi-bell-off"
                      }}</v-icon>
                    </v-btn>
                  </template>

                  <v-sheet color="rgb(20,20,20)" class="pb-2">
                    <v-slider
                      v-model="notificationSoundVolume"
                      vertical
                      color="white"
                      track-color="#888888"
                      min="0"
                      max="1"
                      step="0.01"
                      style="overflow: hidden"
                      @change="audio.volume = notificationSoundVolume;"
                    >
                      <template v-slot:prepend
                        ><v-icon
                          color="white"
                          class="pt-1"
                          @click="toggleMuteNotifications()"
                          >{{
                            notificationSoundVolume > 0
                              ? "mdi-volume-high"
                              : "mdi-volume-off"
                          }}</v-icon
                        >
                      </template>
                    </v-slider>
                  </v-sheet>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
            </v-input>
          </v-form>
        </v-row>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<style>
/* width */
.whiteScroll *::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

/* Track */
.whiteScroll * ::-webkit-scrollbar-track {
  background: rgb(230, 230, 230) !important;
}

/* Handle */
.whiteScroll * ::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
.whiteScroll * ::-webkit-scrollbar-thumb:hover {
  background: rgb(170, 170, 170) !important;
}

/* width */
.blackScroll *::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

#customScroll::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

#customScroll::-webkit-scrollbar-track {
  background: rgb(40, 40, 40) !important;
}

#customScroll::-webkit-scrollbar-thumb {
  background: rgb(10, 10, 10) !important;
  border-radius: 40px !important;
}

#customScroll::-webkit-scrollbar-thumb:hover {
  background: rgb(18, 18, 18) !important;
}

/* Track */
.blackScroll * ::-webkit-scrollbar-track {
  background: rgb(30, 30, 30) !important;
}

/* Handle */
.blackScroll * ::-webkit-scrollbar-thumb {
  background: rgb(20, 20, 20) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
.blackScroll * ::-webkit-scrollbar-thumb:hover {
  background: rgb(18, 18, 18) !important;
}

video::-webkit-media-controls-play-button,
video::-webkit-media-controls-timeline,
video::-webkit-media-controls-current-time-display {
  display: none !important;
}

.roomDescriptionInput textarea {
  margin-top: 0px;
  margin-bottom: 0px;
  min-height: 48px;
  max-height: 48px;
}

/* width */
.roomDescriptionInput *::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

/* Track */
.roomDescriptionInput * ::-webkit-scrollbar-track {
  background: rgb(230, 230, 230) !important;
}

/* Handle */
.roomDescriptionInput * ::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
.roomDescriptionInput * ::-webkit-scrollbar-thumb:hover {
  background: rgb(170, 170, 170) !important;
}




/* width */
.CategorySelector *::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

/* Track */
.CategorySelector *::-webkit-scrollbar-track {
  background: rgb(230, 230, 230) !important;
}

/* Handle */
.CategorySelector *::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
.CategorySelector *::-webkit-scrollbar-thumb:hover {
  background: rgb(170, 170, 170) !important;
}




.v-slider__thumb * {
  color: black !important;
}

.streaming {
  background-image: none !important;
  background-color: black !important;
}

.userMenuHover * {
  z-index: 100000 !important;
}

.disabled {
  opacity: 0.4;
  cursor: default !important;
}

.hidden-h-scroll::-webkit-scrollbar {
  display: none !important;
}

.disabled-button {
  cursor: default !important;
  pointer-events: none;
  color: rgb(70, 70, 70) !important;
}

#videoPlayer {
  position: absolute;
  background-image: radial-gradient(rgb(70, 70, 70), black);
}

.messages .v-avatar {
  align-self: start;
  margin-top: 15px !important;
}

.messages {
  background-color: rgb(70.7, 70);
  padding-right: 0px;
  /* width:330px; */
  margin-top: -15px;
}

.messages:first-child {
  margin-top: 0px;
}

.messages .v-list-item__subtitle {
  display: inline-block;
  word-wrap: break-word;
  white-space: pre-line;
  line-height: 20px;
  width: 100%;
}

#emoticonss {
  padding: 0;
}

#emoticonss > li {
  display: inline;
  padding: 5px;
}

#emoticons {
  display: inline-flex;
  margin-top: 6px;
}

#emoticons li {
  display: inline;
  padding-right: 12px;
}

#emoticons li:last-child {
  padding-right: 6px;
}

#controls .v-icon {
  color: white !important;
}

#controls {
  position: absolute;
  background-color: rgb(20, 20, 20);
  box-shadow: inset 0px -5px 10px -5px black;
  width: 100%;
  height: 40px;
}

#controls .row {
  margin-top: 2px !important;
}

#chat {
  overflow-y: auto;
  overflow-x: hidden;
}

#chatInput {
  position: absolute;
  bottom: 43px;
  width: 100%;
  height: 40px;
}

#users {
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 45px !important;
  white-space: nowrap;
  padding-right: 10px;
  padding-left: 0px !important;
}

#users > li {
  display: inline-block;
}

#users .v-responsive__content {
  /* border: 2px solid rgb(230, 230, 230); */
  /* box-shadow: inset 0px 0px 3px 1px rgba(0, 0, 0, 0.25); */
  /* box-shadow: 0 0 5px 0px white inset, 0 0 5px 0px white; */
}

#underVideo {
  position: absolute;
  bottom: 0;
  /* background-color: rgb(50,50,50); */
  background-image: linear-gradient(rgb(40, 40, 40), rgb(20, 20, 20));
  box-shadow: inset 0px 5px 15px -5px black;
  overflow-y: visible !important;
  overflow-x: auto;
}
</style>

<script>
import { Utility } from "@/tools/utility.js";
import {
  Emoticons,
  Categories,
  DefaultConstraints,
  AcceptedDomains
} from "@/tools/config.js";
import { Users, Messages } from "@/tools/templates.js";
import PrivateHost from "@/hosting/private/main.js";
import PublicHost from "@/hosting/public/main.js";
import Viewer from "@/viewing/main.js";
import Reactions from "@/components/reactions.vue";
import twemoji from "twemoji";
import EmoticonSelector from "@/components/emoticonSelector.vue";
import GifSelector from "@/components/gifSelector.vue";
import RoomChange from "@/components/roomChange.vue";

export default {
  components: { Reactions, EmoticonSelector, GifSelector, RoomChange },
  data: () => ({
    emoticons: [],
    twemoji: twemoji,
    categories: Categories,
    roomNameRules: [
      v => !!v || "Room name is required",
      v => (v && v.length > 3) || "Must be > 3 characters",
      v => (v && v.length <= 25) || "Must be <= 25 characters"
    ],
    roomDescriptionRules: [
      v => !v || true,
      v => v.length == 0 || v.length > 15 || "Must be > 15 characters",
      v => v.length <= 128 || "Must be <= 128 characters"
    ],
    publicRoomDescriptionRules: [
      v => !!v || "Description is required",
      v => (v && v.length > 15) || "Must be > 15 characters",
      v => (v && v.length <= 128) || "Must be <= 128 characters"
    ],
    coverURLRules: [
      v => !!v || "Cover URL is required",
      v =>
        new RegExp(
          "^(https?:\\/\\/)?" +
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
            "((\\d{1,3}\\.){3}\\d{1,3}))" +
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
            "(\\?[;&a-z\\d%_.~+=-]*)?" +
            "(\\#[-a-z\\d_]*)?$",
          "i"
        ).test(v) || "URL is invalid"
    ],
    volumeSlider: 100,
    volumeOld: null,
    volumeIcon: "mdi-volume-high",
    qualitySetting: true,
    categoryRules: [v => !!v || "Category is required"],
    privateRoom: false,
    publicRoom: false,
    streaming: false,
    coverURLErrors: [],
    messageErrors: [],
    messageInput: "",
    coverURL: "",
    users: Users,
    messages: Messages,
    categorySelector: null,
    publicRoomName: "",
    publicRoomDescription: "",
    privateRoomDescription: "",
    privateRoomName: "",
    host: null,
    viewer: null,
    muted: true,
    joining: false,
    roomID: null,
    unlistRoom: false,
    reactionIDs: [],
    theatreMode: false,
    audio: new Audio(require("@/assets/notification.mp3")),
    roomOwner: null,
    roomName: "",
    roomDescription: "",
    topHeaderOffset: 0,
    isPublic: false,
    roomCategory: null,
    roomCoverURL: null,
    roomIsListed: null,
    acceptedDomains: AcceptedDomains,
    notificationSoundVolume: 0.5,
    notificationSoundVolumeSaved: 0.5,
    allEmoticons: Emoticons,
    privateButtonLoading: false,
    publicButtonLoading: false,
    showTutorial: false,
    tapTargetFocus: null,
    targetTitle: "",
    targetContent: ""
  }),
  created() {
    window.addEventListener("resize", this.resize);
    this.resize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.notificationSoundVolume = localStorage.getItem("notificationVolume") || 0.5;
      this.audio.volume = this.notificationSoundVolume;
    this.init();

    if (this.$root.targetStage() == 3) {
      this.$nextTick(() => {
        this.tapTargetFocus = this.$refs.topHeader;
        this.showTutorial = true;
        this.targetTitle =
          "This is where you'll find Room names and descriptions";
        this.targetContent =
          "When in your own room, you can hover over this to change the details.";
      });
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    screenLoader() {
      return this.$store.state.screenLoader;
    }
  },
  watch: {
    host: function(newV) {
      this.$emit("host", newV !== null);
    },
    streaming: function(newV) {
      if (!newV) {
        this.theatreMode = false;
        this.$emit("theatreMode", this.theatreMode);
        this.$store.commit("setSidebarToggled", true);
      }
      this.$emit("streaming", newV);
      this.resize();
    },
    user: function() {
      this.init();
    },
    users: function(newV) {
      this.$emit("users", newV);
    },
    theatreMode: function(newV) {
      this.$emit("theatreMode", newV);
    },
    coverURL: function(v) {
      let $this = this;

      if (!v) {
        $this.coverURLErrors = ["Cover URL is required"];
        return;
      } else if (
        !new RegExp(
          "^(https?:\\/\\/)?" +
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
            "((\\d{1,3}\\.){3}\\d{1,3}))" +
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
            "(\\?[;&a-z\\d%_.~+=-]*)?" +
            "(\\#[-a-z\\d_]*)?$",
          "i"
        ).test(v)
      ) {
        $this.coverURLErrors = ["URL is invalid"];
        return;
      } else if (v.includes(".gif") && $this.user.tier !== 'Advocate') {
        $this.coverURLErrors = ["Only Advocates can use GIFs"];
      } else {
        $this.coverURLErrors = [];
      }
    },
    volumeSlider: function(newV) {
      this.$refs.player.volume = newV / 100;

      if (newV == 0) {
        this.volumeIcon = "mdi-volume-off";
        this.muted = true;
      } else {
        this.volumeIcon = "mdi-volume-high";
        this.muted = false;
      }
    },
    roomID: function(newV) {
      this.$emit("roomID", newV);
    }
  },
  beforeRouteLeave(to, from, next) {
    //eslint-disable-line
    this.theatreMode = false;
    this.$store.commit("setSidebarToggled", true);
    this.$emit("theatreMode", this.theatreMode);
    if (this.streaming) {
      if (this.viewer !== null) {
        this.$root
          .$confirm(
            "Are you sure?",
            "Leaving will disconnect you from the room.",
            { color: "red" }
          )
          .then(confirm => {
            if (confirm) {
              this.$socket.emit("disconnect from room", () => {
                this.viewer.close(() => {
                  this.sockets.unsubscribe("receive message");
                  this.sockets.unsubscribe("receive reaction");
                  next();
                });
              });
            }
          });
      } else if (this.host !== null) {
        this.$root
          .$confirm("Are you sure?", "Leaving will close your room.", {
            color: "red"
          })
          .then(confirm => {
            if (confirm) {
              this.host.close(() => {
                this.sockets.unsubscribe("receive message");
                this.sockets.unsubscribe("receive reaction");
                next();
              });
            }
          });
      }
    } else {
      next();
    }
  },
  methods: {
    notificationSoundMenu() {
      // localStorage.setItem('notificationVolume',this.notificationSoundVolume); 
    },
    onMessageImageLoad() {
      let chat = document.getElementById("chat");
      if (
        Math.abs(chat.scrollTop - (chat.scrollHeight - chat.offsetHeight)) <=
        100
      ) {
        let newChat = document.getElementById("chat");
        newChat.scrollTop = newChat.scrollHeight;
      }
    },
    toggleMuteNotifications() {
      if (this.notificationSoundVolume == 0) {
        this.notificationSoundVolume = this.notificationSoundVolumeSaved;
      this.audio.volume = this.notificationSoundVolume;

      } else {
        this.notificationSoundVolumeSaved = this.notificationSoundVolume;
        this.notificationSoundVolume = 0;
      this.audio.volume = this.notificationSoundVolume;
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeTheatreMode() {
      if (this.theatreMode == 0) {
        this.theatreMode = 1;
      } else if (this.theatreMode == 1) {
        this.theatreMode = 2;
      } else if (this.theatreMode == 2) {
        this.theatreMode = 0;
      }

      if (this.theatreMode == 1 || this.theatreMode == 2) {
        this.$store.commit("setSidebarToggled", false);
      } else {
        this.$store.commit("setSidebarToggled", true);
      }
    },
    resize() {
      this.$nextTick(() => {
        if (window.location.href.split("/")[3] == this.user.username) {
          if (this.isMobile()) {
            // this.$router.replace("/");
          }
        }
        let topHeader = this.$refs.topHeader;

        if (topHeader) {
          this.topHeaderOffset = topHeader.$el.clientHeight;
        }
      });
    },
    init() {
      this.sockets.unsubscribe("receive message");
      this.sockets.unsubscribe("delete message");
      this.sockets.unsubscribe("receive reaction");
      this.sockets.unsubscribe("receive change details");

      this.sockets.subscribe("receive change details", object => {
        this.roomName = object.newName;
        this.roomDescription = object.newDescription;
        this.isPublic = object.isPublic;
        this.roomCategory = object.category;
        this.roomCoverURL = object.coverURL;
        this.roomIsListed = object.listed;
      });

      this.sockets.subscribe("receive message", message => {
        let chat = document.getElementById("chat");
        let scroll = false;

        if (
          Math.abs(chat.scrollTop - (chat.scrollHeight - chat.offsetHeight)) <=
          100
        ) {
          scroll = true;
        }

        message.timestamp = new Date(message.timestamp);

        if (this.messages.length && this.roomID) {
          let original = this.messages[this.messages.length - 1];
          let diffms = Math.abs(message.timestamp - original.timestamp);
          let diff = Math.floor(diffms / 1000 / 60);

          if (
            message.user.id == original.user.id &&
            diff < 5 &&
            original.deleted !== true
          ) {
            this.messages[this.messages.length - 1].body += "\n" + message.body;
            this.messages[this.messages.length - 1].presentable = this.urlify(
              this.messages[this.messages.length - 1]
            );

            this.$nextTick(() => {
              let newChat = document.getElementById("chat");
              if (scroll) newChat.scrollTop = newChat.scrollHeight;
            });
          } else {
            if (
              this.messages
                .map(m => {
                  return m.id;
                })
                .includes(message.id)
            )
              return;
            if (this.messages.length >= 25) this.messages.shift();
            message.presentable = this.urlify(message);
            this.messages.push(message);

            this.$nextTick(() => {
              let newChat = document.getElementById("chat");
              if (scroll) newChat.scrollTop = newChat.scrollHeight;
            });
          }
        } else {
          if (
            this.messages
              .map(m => {
                return m.id;
              })
              .includes(message.id)
          )
            return;
          if (this.messages.length >= 25) this.messages.shift();
          message.presentable = this.urlify(message);
          this.messages.push(message);

          this.$nextTick(() => {
            let newChat = document.getElementById("chat");
            if (scroll) newChat.scrollTop = newChat.scrollHeight;
          });
        }

        if (this.user.chatNotifications && message.user.id !== this.user.id) {
          this.audio.play();
        }
      });

      this.sockets.subscribe("delete message", message => {
        for (let i = 0; i < this.messages.length; i++) {
          let msg = this.messages[i];
          console.info(msg.body + " : " + message.body); // eslint-disable-line
          if (msg.id == message.id) {
            this.messages[i].presentable = "This message was removed.";
            this.messages[i].body = "This message was removed.";
            this.messages[i].deleted = true;
            this.messages[i].image = false;
          }
        }
      });

      this.sockets.subscribe("recieve reaction", reaction => {
        this.$nextTick(() => {
          if (this.reactionIDs.includes(reaction.id)) return;
          this.reactionIDs.push(reaction.id);
          if (this.$refs.reactionRenderer)
            this.$refs.reactionRenderer.addEmoticon(reaction.emoticon);
        });
      });

      this.users = [];
      this.messages = [];
      this.reactionIDs = [];
      let titleUsername = window.location.href.split("/")[3];
      document.title = titleUsername + "'s Room";
      if (this.user) {
        this.emoticons = this.user.emoticons;
        if (titleUsername == this.user.username) {
          if (this.isMobile()) {
            // this.$router.replace("/");
          }
          if (
            !this.users
              .map(user => {
                return user.id;
              })
              .includes(this.user.id)
          ) {
            this.users.unshift(this.user);
            this.muted = false;
          }
        } else {
          this.joining = true;
          this.viewer = new Viewer(this, window.location.href.split("/")[3]);
          this.viewer.init();
        }
      }
    },

    toggleDisplayReactions() {
      this.user.displayReactions = !this.user.displayReactions;
      let object = {
        setting: "displayReactions",
        value: this.user.displayReactions
      };
      this.$socket.emit("save preference", this.user, object);
      this.$store.commit("setUser", this.user);
    },

    swapEmoticon(index) {
      //eslint-disable-line
      this.$refs.EmoticonSelector.open().then(result => {
        if (result) {
          this.emoticons[index] = result;
          this.$forceUpdate();
          let object = {
            setting: "emoticons",
            roomID: this.roomID,
            value: this.emoticons
          };
          this.$socket.emit("save preference", this.user, object);
        }
      });
    },

    findColour(item, categories) {
      for (let i = 0; i < categories.length; i++) {
        if (categories[i].name == item) {
          return categories[i].colour;
        }
      }
      return "black";
    },

    hostInURL(avatarUser) {
      return (
        this.user.username !== avatarUser.username &&
        window.location.href.split("/")[3] == this.user.username
      );
    },

    urlify(message) {
      let text = message.body;
      let urlRegex = /(https?:\/\/[^\s]+)/g;
      let lines = text.split(/\r?\n/);

      if (lines == null) return text;
      if (!lines.length) return text;

      console.log("yeah", message); //eslint-disable-line

      for (let i = 0; i < lines.length; i++) {
        let spaced = lines[i].split(" ");
        for (let k = 0; k < spaced.length; k++) {
          let matches = spaced[k].match(urlRegex);
          if (matches == null) continue;
          for (let j = 0; j < matches.length; j++) {
            if (
              spaced[k].includes("png") ||
              spaced[k].includes("jpg") ||
              spaced[k].includes("jpeg") ||
              spaced[k].includes("gif")
            ) {
              let domain = new URL(spaced[k]).hostname;

              if (this.acceptedDomains.includes(domain))
                message.image = spaced[k];
            }

            spaced[k] = spaced[k].replace(
              matches[j],
              `<a target="_blank" href="${matches[j]}">${matches[j]}</a>`
            );
          }
        }
        lines[i] = spaced.join(" ");
      }

      // console.log(lines.join("\n")) //eslint-disable-line
      return lines.join("<br>");
    },

    openGifs() {
      this.$refs.GifSelector.open().then(gif => {
        if (this.messageInput.length == 0) {
          this.messageInput = gif;
          this.sendMessage();
        } else {
          this.messageInput += " " + gif;
        }
      });
    },

    chatNotifications() {
      this.user.chatNotifications = !this.user.chatNotifications;
      this.$socket.emit("chat notifications", {
        userID: this.user.id,
        value: this.user.chatNotifications
      });
      this.$store.commit("setUser", this.user);
    },

    volumeToggle() {
      if (this.volumeIcon == "mdi-volume-high") {
        this.volumeOld = this.volumeSlider;
        this.volumeSlider = 0;
        this.volumeIcon = "mdi-volume-off";
      } else {
        this.volumeSlider = this.volumeOld;
        this.volumeIcon = "mdi-volume-high";
      }
    },
    videoFullscreen: function() {
      let player = this.$refs.player;

      if (this.streaming) {
        if (player.requestFullscreen) {
          player.requestFullscreen();
        } else if (player.msRequestFullscreen) {
          player.msRequestFullscreen();
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen();
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen();
        }
      }
    },
    videoQualityToggle: function() {
      if (this.host) {
        if (this.qualitySetting) {
          this.$root
            .$confirm(
              "Are you sure?",
              "When your streaming source is not in full screen, lowering the quality can crop the sides.",
              {}
            )
            .then(confirm => {
              if (confirm) {
                this.host.changeQuality("low");
                this.qualitySetting = false;
              }
            });
        } else {
          this.host.changeQuality("high");
          this.qualitySetting = true;
        }
      }
    },
    formatDate(date) {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      let strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    copyToClipboard(text) {
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
      } catch (err) {} //eslint-disable-line

      document.body.removeChild(textArea);
    },

    //
    // Streaming
    //

    kickViewer(viewer) {
      this.$root
        .$confirm("Are you sure?", "That action cannot be undone.", {})
        .then(confirm => {
          if (confirm) {
            this.$socket.emit("kick viewer", {
              viewer: viewer,
              roomID: this.roomID
            });
          }
        });
    },

    friendViewer(viewer) {
      this.$root
        .$confirm(
          "Are you sure?",
          `Befriending ${viewer.username} will enable them to join your private rooms.`,
          {}
        )
        .then(confirm => {
          if (confirm) {
            this.$socket.emit(
              "add friend viewer",
              { userID: this.user.id, viewerID: viewer.id },
              response => {
                if (response) {
                  if (response.error) {
                    if (response.error == "unknown") {
                      this.$root.$alert(
                        "Error",
                        "An unknown error has occured.",
                        {
                          color: "red accent-4"
                        }
                      );
                    } else if (response.error == "already friend") {
                      this.$root.$alert(
                        "Error",
                        `<b>${viewer.username}</b> is already your friend.`,
                        {
                          color: "red accent-4"
                        }
                      );
                    }
                  } else if (response.success) {
                    this.user.friends = response.success;
                    this.$store.commit("setUser", this.user);
                    this.$root.$alert("Success", "Successfully added friend.");
                  }
                }
              }
            );
          }
        });
    },

    banViewer(viewer) {
      this.$root
        .$confirm("Are you sure?", "That action cannot be undone.", {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            this.$socket.emit("ban viewer", {
              viewer: viewer,
              roomID: this.roomID
            });
          }
        });
    },

    sendMessage() {
      if (!this.messageInput.length && this.roomID) {
        this.messageErrors.push("");
      } else {
        let message = {
          timestamp: new Date(),
          userID: this.user.id,
          body: this.messageInput
        };
        console.log(message); //eslint-disable-line
        this.messageInput = "";
        this.$socket.emit("send message", {
          message: message,
          roomID: this.roomID
        });
      }
    },

    deleteMessage(message) {
      this.$root
        .$confirm("Are you sure?", "That action cannot be undone.", {})
        .then(confirm => {
          if (confirm) {
            if (
              this.hostInURL(message.user) ||
              message.user.id == this.user.id
            ) {
              this.$socket.emit("delete message", {
                message: message,
                roomID: this.roomID
              });
            }
          }
        });
    },

    sendReaction(emoticon) {
      this.$socket.emit("send reaction", {
        emoticon: emoticon,
        roomID: this.roomID
      });
    },

    setStream(stream) {
      this.$refs.player.srcObject = stream;
      this.streaming = true;
      this.privateButtonLoading = false;
      this.publicButtonLoading = false;
    },
    getStream(constraints, callback) {
      navigator.mediaDevices.getDisplayMedia(constraints).then(mediaStream => {
        if (mediaStream.getAudioTracks().length == 0) {
          this.$root
            .$confirm(
              "Are you sure?",
              "You've not selected to share audio.",
              {}
            )
            .then(confirm => {
              if (confirm) {
                callback(mediaStream);
              } else {
                mediaStream.getTracks().forEach(track => track.stop());
                this.getStream(constraints, callback);
              }
            });
        } else {
          callback(mediaStream);
        }
      });
    },

    closeViewer(force) {
      document.title = this.user.username + "'s Room";
      this.joining = false;
      this.streaming = false;
      this.$nextTick(() => {
        this.$refs.player.srcObject = null;
      });
      this.users = [this.user];
      this.roomName = "";
      this.roomDescription = "";
      if (!force) {
        this.$router.push({
          path: "/"
        });
      }
      this.viewer = null;
      this.roomID = null;
      this.messages = [];
      this.emoticons = this.user.emoticons;
    },

    closeHost() {
      document.title = this.user.username + "'s Room";
      this.streaming = false;
      this.$refs.player.srcObject = null;
      this.users = [this.user];
      this.roomName = "";
      this.roomDescription = "";
      this.host = null;
      this.roomID = null;
      this.private = false;
      this.isPublic = false;
      this.roomCategory = false;
      this.roomCoverURL = false;
      this.roomIsListed = false;
      this.messages = [];
      this.privateButtonLoading = false;
      this.publicButtonLoading = false;
    },

    hostPublic() {
      let $this = this;
      if (this.$refs.publicForm.validate()) {
        this.publicButtonLoading = true;
        Utility.testImage(this.coverURL, function(outcome) {
          $this.publicButtonLoading = false;
          if ($this.user.tier !== 'Advocate' && $this.coverURL.includes(".gif")) {
            return ($this.coverURLErrors = ["Only Advocates can use GIFs"]);
          }
          if (outcome == "success") {
            $this.getStream(DefaultConstraints, stream => {
              $this.host = new PublicHost($this, stream);
              $this.host.begin();
              $this.$emit("roomCover", $this.coverURL);
            });
          } else {
            $this.coverURLErrors = ["URL isn't an image"];
          }
        });
      }
    },

    hostPrivate() {
      let $this = this;
      if (this.$refs.privateForm.validate()) {
        this.getStream(DefaultConstraints, stream => {
          this.privateButtonLoading = true;
          this.host = new PrivateHost($this, stream);
          this.host.begin();
        });
      }
    }
  }
};
</script>
